module.exports = __webpack_public_path__ + "img/icon-long-tail-keywords.f14bd84f.svg";